import localStorageEx from 'bundles/common/utils/localStorageEx';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { NOTIFICATION_DISMISS_PERIOD } from './NotificationUtils';

export class EnterpriseAdminNotificationStorage {
  // notification storage key
  static key = 'EnterpriseAdminNotification_dismiss';

  static isDismissed(contractId: string, notificationId: string) {
    const now = new Date(Date.now()).valueOf();
    const value = localStorageEx.getItem<Record<string, number | undefined>>(
      EnterpriseAdminNotificationStorage.key,
      JSON.parse,
      {}
    );

    const notificationKey = `${notificationId}~${contractId}`;
    const dismissedAt = value[notificationKey];

    return dismissedAt && now - dismissedAt < NOTIFICATION_DISMISS_PERIOD;
  }

  static dismiss(contractId: string, notificationId: string) {
    const now = new Date(Date.now()).valueOf();
    const value = localStorageEx.getItem(EnterpriseAdminNotificationStorage.key, JSON.parse, {});

    const notificationKey = `${notificationId}~${contractId}`;
    value[notificationKey] = now;

    localStorageEx.setItem(EnterpriseAdminNotificationStorage.key, value, JSON.stringify);
  }
}
